




















































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'
import ScrollView from '@/components/ScrollView.vue'
import { EOrigin, EPaymentsDepositStatus, IFacility } from '@zunta/configurations'
import { formatMoney } from '@/utils/helpers'
import { StatementModule } from '@/store/modules/statement.module'

const groupBy = require('lodash.groupby')
const uniqBy = require('lodash.uniqby')

@Component({
  components: { Modal, ScrollView },
  props: {
    isReview: {
      type: Boolean,
      default: false
    },
    batchId: {
      type: Number,
      default: null
    }
  }
})
export default class GenerationAlertModal extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)

  get facilitiesPaymentsNotInSync () {
    return this.$store.state.payments.facilitiesPaymentsNotInSync
  }

  get facilitiesList () {
    return this.$store.state.facility.facilities
  }

  get rows () {
    const grouped = groupBy(this.$store.state.payments.facilitiesPaymentsNotInSync, 'payment.willowDepositId')
    const rows = []
    for (const willowDepositId in grouped) {
      const deposit = grouped[willowDepositId][0].payment.deposit
      const record = {
        willowDepositId,
        deposit,
        origin: grouped[willowDepositId][0].payment.resident.origin,
        payments: uniqBy(
            grouped[willowDepositId].map((ps: any) => {
              return `${ps.payment.resident.firstName} ${ps.payment.resident.lastName}`
            })
        ).join(', ')
      }
      rows.push(record)
    }
    return rows
  }

  get facilityOriginLabel () {
    const isNCS = this.facilitiesList.find((facility: IFacility) => facility.origin === EOrigin.NCS)
    const isPCC = this.facilitiesList.find((facility: IFacility) => facility.origin === EOrigin.PCC)
    if (isNCS && isPCC) {
      return 'NCS/PCC'
    }
    if (isPCC) {
      return 'PCC'
    }
    return 'NCS'
  }

  get uniqResidentsList () {
    const residents = this.facilitiesPaymentsNotInSync.map((item: any) => item.payment.resident)
    return uniqBy(residents, 'id')
  }

  goToDeposits () {
    this.$router.push({
      name: 'management-payments-sections-deposits'
    })
  }

  getDepositStatus (row: any) {
    if (row.deposit.status !== EPaymentsDepositStatus.SYNCED) {
      return 'Not Posted'
    }
    return row.origin === EOrigin.PCC ? 'In PCC' : 'In NCS'
  }

  async confirmPopup () {
    if (this.$props.isReview) {
      await this.statementModuleInstance.confirmNotPostedPopup(this.$props.batchId)
      this.$emit('process')
    } else {
      this.$emit('confirm')
    }
  }
}
